import React, { useEffect, useRef } from "react";

/**
 * Textarea que cresce verticalmente conforme o usuário digita.
 * Mantém o visual do Input shadcn (border, focus ring) e começa com 1 linha,
 * expandindo até `maxRows`.
 */
export default function AutoGrowTextarea({
  value,
  onChange,
  minRows = 1,
  maxRows = 10,
  className = "",
  ...rest
}) {
  const ref = useRef(null);

  const resize = () => {
    const el = ref.current;
    if (!el) return;
    el.style.height = "auto";
    const style = window.getComputedStyle(el);
    const lineHeight = parseFloat(style.lineHeight) || 20;
    const paddingY = parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
    const maxHeight = lineHeight * maxRows + paddingY;
    const next = Math.min(el.scrollHeight, maxHeight);
    el.style.height = `${next}px`;
    el.style.overflowY = el.scrollHeight > maxHeight ? "auto" : "hidden";
  };

  useEffect(() => { resize(); }, [value]); // eslint-disable-line

  return (
    <textarea
      ref={ref}
      rows={minRows}
      value={value}
      onChange={onChange}
      className={
        "flex w-full rounded-md border border-slate-200 bg-white px-3 py-2 text-sm " +
        "placeholder:text-slate-400 focus-visible:outline-none focus-visible:ring-2 " +
        "focus-visible:ring-[#7c3aed] disabled:cursor-not-allowed disabled:opacity-50 " +
        "resize-none leading-relaxed " +
        className
      }
      {...rest}
    />
  );
}
